import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";

// Enum options extracted from Ruby FileDeliveryConcern::Enums
export const statusOptions = [{ value: "sent", label: "Sent" }];

export const filterFileDeliverySchema = z.object({
  time_serie_file_date_id_contains: z.string().nullable().optional(),
  client_portfolio_id_equals: z.string().nullable().optional(),
  status_contains: z.string().nullable().optional(),
  api_url_contains: z.string().nullable().optional(),
  sent_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  sent_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterFileDeliverySchema = z.infer<typeof filterFileDeliverySchema>;

export const fields: Field[] = [
  {
    name: "time_serie_file_date_id_contains",
    label: "Time Serie File Date",
    type: "input",
  },
  {
    name: "client_portfolio_id_equals",
    label: "Client Portfolio",
    type: "input",
  },
  {
    name: "status_contains",
    label: "Status",
    type: "select",
    useTranslation: false,
    options: statusOptions,
  },
  {
    name: "api_url_contains",
    label: "API URL",
    type: "input",
  },
  {
    name: "sent_at_from",
    label: "Sent At From",
    type: "date",
  },
  {
    name: "sent_at_to",
    label: "Sent At To",
    type: "date",
  },
  {
    name: "created_at_from",
    label: "Created At From",
    type: "date",
  },
  {
    name: "created_at_to",
    label: "Created At To",
    type: "date",
  },
];

export const client = "qtl - etl";

export function FilterFileDelivery() {
  return (
    <FilterTable
      client={client}
      schema={filterFileDeliverySchema}
      tableName="file_deliveries"
      customBuildPath={() => `${client}/file_deliveries`}
      fields={fields}
    />
  );
}
